import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { readAttendancePreset, hasAttendancePreset } from '../../../utils/attendanceFilterQuery';

/**
 * Devam Paneli'nden gelen süzgeçler (sorgu dizesi sözleşmesi — utils/attendanceFilterQuery). preset adresten türetilir;
 * clearPreset adresteki sorguyu siler (history.replace — geri tuşu süzgeci geri getirmez).
 */
export function useAttendancePreset() {
  const location = useLocation();
  const history = useHistory();
  const preset = useMemo(() => {
    const parsed = readAttendancePreset(location.search);
    return hasAttendancePreset(parsed) ? parsed : null;
  }, [location.search]);
  const clearPreset = useCallback(() => {
    history.replace({ pathname: location.pathname, search: '' });
  }, [history, location.pathname]);
  return { preset, clearPreset };
}

export default useAttendancePreset;
